// TenantDashboard.styles.js
// Styles for Tenant Dashboard

import theme from "../../theme";

const TenantDashboardStyles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#f4f4f9",
    padding: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    padding: "16px 24px",
    backgroundColor: theme.colors.white,
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
  },
  logo: {
    height: 50,
    width: "auto",
  },
  welcomeText: {
    color: theme.colors.black,
    fontWeight: 600,
  },
  logoutButton: {
    color: theme.colors.mediumGray,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, 1fr)",
      lg: "repeat(4, 1fr)",
    },
    gap: "24px",
    marginBottom: "24px",
    alignItems: "stretch",
  },
  card: {
    backgroundColor: theme.colors.white,
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    "&:nth-of-type(-n+4)": {
      minHeight: 320,
      maxHeight: 420,
    },
  },
  cardTitle: {
    color: theme.colors.black,
    fontWeight: 600,
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  statusChip: {
    fontWeight: 600,
    borderRadius: "6px",
  },
  statusActive: {
    backgroundColor: "rgba(129, 194, 65, 0.15)",
    color: "#81c241",
  },
  statusPending: {
    backgroundColor: "rgba(102, 102, 102, 0.15)",
    color: "#666666",
  },
  statusCancelled: {
    backgroundColor: "rgba(51, 51, 51, 0.15)",
    color: "#333333",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: "1px solid #eee",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  infoLabel: {
    color: theme.colors.mediumGray,
    fontSize: "14px",
  },
  infoValue: {
    color: theme.colors.black,
    fontWeight: 500,
  },
  accessCodeContainer: {
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
    padding: "24px",
    textAlign: "center",
    marginTop: "16px",
    border: "1px solid #e9ecef",
  },
  accessCodeDisplay: {
    fontFamily: "monospace",
    fontSize: "32px",
    fontWeight: 700,
    letterSpacing: "6px",
    color: theme.colors.green,
    padding: "20px",
    backgroundColor: theme.colors.white,
    borderRadius: "12px",
    border: `2px solid ${theme.colors.green}`,
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  dialogContent: {
    padding: "24px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: theme.colors.black,
    marginBottom: "16px",
    paddingBottom: "8px",
    borderBottom: "2px solid #f0f0f0",
  },
  lockInfoBox: {
    p: 2,
    backgroundColor: "#f8f9fa",
    borderRadius: 2,
    border: "1px solid #e9ecef",
    mt: 2,
  },
  expiryText: {
    color: theme.colors.mediumGray,
    fontSize: "14px",
    marginTop: "8px",
  },
  countdownText: {
    color: "#666666",
    fontWeight: 600,
    fontSize: "16px",
  },
  primaryButton: {
    marginTop: "16px",
    padding: "12px 24px",
    borderRadius: "8px",
    backgroundColor: theme.colors.green,
    color: theme.colors.white,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.colors.greenHover || "#6aa832",
    },
    "&:disabled": {
      backgroundColor: theme.colors.lightGray,
    },
  },
  secondaryButton: {
    marginTop: "8px",
    padding: "12px 24px",
    borderRadius: "8px",
    border: `1px solid ${theme.colors.green}`,
    color: theme.colors.green,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(129, 194, 65, 0.08)",
    },
  },
  copyButton: {
    marginLeft: "8px",
    color: theme.colors.green,
  },
  noCodeMessage: {
    color: theme.colors.mediumGray,
    textAlign: "center",
    padding: "24px",
  },
  propertyCard: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "16px",
    backgroundColor: "#f4f4f9",
    borderRadius: "8px",
  },
  propertyIcon: {
    fontSize: "48px",
    color: theme.colors.green,
  },
  propertyInfo: {
    flex: 1,
  },
  propertyAddress: {
    fontWeight: 600,
    color: theme.colors.black,
  },
  propertyId: {
    color: theme.colors.mediumGray,
    fontSize: "12px",
  },
};

export default TenantDashboardStyles;
